<template lang="pug">
    v-layout(row wrap)
        v-flex.pa-2(md12)
            //v-toolbar( dark='' tabs='')
            v-tabs(:color="colors.tertiary" dark slider-color="yellow" v-model="tabModel")
                v-tab(ripple href='#tab-1') Antecedente
                v-tab(ripple href='#tab-2') Finiquito
            v-tabs-items(v-model="tabModel")
                v-tab-item(my-3 id="tab-1")
                    precedent-tab(@precedentFormDone="goToTab2")
                v-tab-item(my-3 id="tab-2")
                    finiquito-tab(:dataPrecedent="formDataPrecedent")
</template>

<script>
import Precedent from '../precedent/Precedent'
import Finiquito from '../finiquito/Finiquito'
export default {
    name: 'main-tab',
    // props: {},
    data: function(){
        return {
            tabModel:'tab-1',
            finiquitoData:{},
        }
    },
    computed: {
        formDataPrecedent(){
            return this.finiquitoData
        }
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        goToTab2(data){
            this.setFiniquitoData(data)
            this.tabModel = `tab-2`
        },
        /**
         * 
         */
        setFiniquitoData(data){
            this.finiquitoData = data
        }
    
        // -- Vuex mappings
    },
    // watch: {},
    components: {
        'precedent-tab': Precedent,
        'finiquito-tab' : Finiquito,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>